import { IState } from 'shared/store';
import { IKPSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export const selectKpData = (state: IState): IKPSchema | null => {
  return state.offerData.kp;
};
